import { useLanguageStore, Language } from '../store/useLanguageStore';
import ko from '../locales/ko';
import en from '../locales/en';

const locales = {
  ko,
  en,
};

export const useTranslation = () => {
  const { locale, setLocale } = useLanguageStore();

  const t = (
    key: string,
    defaultValueOrReplacements?: string | Record<string, string | number>,
    replacements?: Record<string, string | number>
  ) => {
    const resource = locales[locale] || locales.ko;
    let translation = (resource as any)[key];

    const actualReplacements = typeof defaultValueOrReplacements === 'object' ? defaultValueOrReplacements : replacements;
    const fallback = typeof defaultValueOrReplacements === 'string' ? defaultValueOrReplacements : undefined;

    if (!translation) {
      translation = fallback || (locales.ko as any)[key] || key;
    }

    if (actualReplacements) {
      Object.keys(actualReplacements).forEach((placeholder) => {
        const value = actualReplacements[placeholder];
        translation = translation.replace(new RegExp(`{{${placeholder}}}`, 'g'), String(value));
      });
    }

    return translation;
  };

  const changeLanguage = (lang: Language) => {
    localStorage.setItem('onkiz_lang', lang);
    setLocale(lang);
  };

  return {
    t,
    locale,
    changeLanguage,
  };
};
export type { Language };
